const hasReconciliationMismatch = (day: any) => {
  const variance = day?.auditTotals?.reconciliation_variance;
  if (!variance) {
    return false;
  }

  return [
    variance.total_variance,
    variance.lotto_sales_variance,
    variance.payout_variance,
    variance.scratcher?.quantity_variance,
    variance.scratcher?.revenue_variance,
  ].some((value) => Number(value || 0) !== 0);
};

const normalizeReconciliationStatus = (status?: string | null) => {
  if (status === "verified") {
    return "approved";
  }
  if (status === "pending_verification") {
    return "needs_resolution";
  }
  if (status === "not_required") {
    return "matched";
  }
  return status ?? null;
};

export const shouldShowReconciliationReview = (day: any, detail?: { hasServerData?: boolean; auditStatus?: string; isVerified?: boolean } | null) => {
  const verified = day?.verified as any;
  const detailStatus = detail?.hasServerData ? normalizeReconciliationStatus(detail.auditStatus) : null;
  const summaryStatus = normalizeReconciliationStatus(verified?.auditStatus ?? verified?.audit_status ?? verified?.status);
  const auditStatus = detailStatus ?? summaryStatus;

  if (auditStatus) {
    return auditStatus !== "matched";
  }

  return hasReconciliationMismatch(day) || detail?.isVerified === true || verified?.is_verified === true;
};
